<script>
import { layoutComputed } from "@/state/helpers"
import { SimpleBar } from "simplebar-vue3"

import { useCounts } from "@/use/useCounts"

export default {
  setup() {
    const { faqCount, commentCount, messageCount, orderCount } = useCounts()

    return {
      faqCount,
      commentCount,
      messageCount,
      orderCount,
    }
  },
  components: {
    SimpleBar,
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
    }
  },
  computed: {
    ...layoutComputed,
    layoutType: {
      get() {
        return this.$store ? this.$store.state.layout.layoutType : {} || {}
      },
    },
    isAdmin: {
      get() {
        return this.$store &&
          this.$store.state.user.data.ur == "admin" &&
          this.$store.getters.isAdmin
          ? true
          : false
      },
    },

    isOperator: {
      get() {
        return this.$store &&
          this.$store.state.user.data.ur == "operator" &&
          this.$store.getters.isOperator
          ? true
          : false
      },
    },

    isSeller: {
      get() {
        return this.$store &&
          this.$store.state.user.data.ur == "seller" &&
          this.$store.getters.isSeller
          ? true
          : false
      },
    },
  },

  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    if (document.querySelectorAll(".navbar-nav .collapse")) {
      let collapses = document.querySelectorAll(".navbar-nav .collapse")

      collapses.forEach((collapse) => {
        // Hide sibling collapses on `show.bs.collapse`
        collapse.addEventListener("show.bs.collapse", (e) => {
          e.stopPropagation()
          let closestCollapse = collapse.parentElement.closest(".collapse")
          if (closestCollapse) {
            let siblingCollapses = closestCollapse.querySelectorAll(".collapse")
            siblingCollapses.forEach((siblingCollapse) => {
              if (siblingCollapse.classList.contains("show")) {
                siblingCollapse.classList.remove("show")
                siblingCollapse.parentElement.firstChild.setAttribute(
                  "aria-expanded",
                  "false"
                )
              }
            })
          } else {
            let getSiblings = (elem) => {
              // Setup siblings array and get the first sibling
              let siblings = []
              let sibling = elem.parentNode.firstChild
              // Loop through each sibling and push to the array
              while (sibling) {
                if (sibling.nodeType === 1 && sibling !== elem) {
                  siblings.push(sibling)
                }
                sibling = sibling.nextSibling
              }
              return siblings
            }
            let siblings = getSiblings(collapse.parentElement)
            siblings.forEach((item) => {
              if (item.childNodes.length > 2) {
                item.firstElementChild.setAttribute("aria-expanded", "false")
                item.firstElementChild.classList.remove("active")
              }
              let ids = item.querySelectorAll("*[id]")
              ids.forEach((item1) => {
                item1.classList.remove("show")
                item1.parentElement.firstChild.setAttribute(
                  "aria-expanded",
                  "false"
                )
                item1.parentElement.firstChild.classList.remove("active")
                if (item1.childNodes.length > 2) {
                  let val = item1.querySelectorAll("ul li a")

                  val.forEach((subitem) => {
                    if (subitem.hasAttribute("aria-expanded"))
                      subitem.setAttribute("aria-expanded", "false")
                  })
                }
              })
            })
          }
        })

        // Hide nested collapses on `hide.bs.collapse`
        collapse.addEventListener("hide.bs.collapse", (e) => {
          e.stopPropagation()
          let childCollapses = collapse.querySelectorAll(".collapse")
          childCollapses.forEach((childCollapse) => {
            let childCollapseInstance = childCollapse
            childCollapseInstance.classList.remove("show")
            childCollapseInstance.parentElement.firstChild.setAttribute(
              "aria-expanded",
              "false"
            )
          })
        })
      })
    }
  },

  methods: {
    onRoutechange(ele) {
      this.initActiveMenu(ele.path)
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition =
          document.getElementsByClassName("mm-active")[0].offsetTop
        if (currentPosition > 500)
          if (this.$refs.isSimplebar)
            this.$refs.isSimplebar.value.getScrollElement().scrollTop =
              currentPosition + 300
      }
    },

    initActiveMenu(ele) {
      setTimeout(() => {
        if (document.querySelector("#navbar-nav")) {
          let a = document
            .querySelector("#navbar-nav")
            .querySelector('[href="' + ele + '"]')
          if (a) {
            a.classList.add("active")
            let parentCollapseDiv = a.closest(".collapse.menu-dropdown")
            if (parentCollapseDiv) {
              parentCollapseDiv.classList.add("show")
              parentCollapseDiv.parentElement.children[0].classList.add(
                "active"
              )
              parentCollapseDiv.parentElement.children[0].setAttribute(
                "aria-expanded",
                "true"
              )
              if (
                parentCollapseDiv.parentElement.closest(
                  ".collapse.menu-dropdown"
                )
              ) {
                parentCollapseDiv.parentElement
                  .closest(".collapse")
                  .classList.add("show")
                if (
                  parentCollapseDiv.parentElement.closest(".collapse")
                    .previousElementSibling
                )
                  parentCollapseDiv.parentElement
                    .closest(".collapse")
                    .previousElementSibling.classList.add("active")
                const grandparent = parentCollapseDiv.parentElement
                  .closest(".collapse")
                  .previousElementSibling.parentElement.closest(".collapse")
                if (
                  grandparent &&
                  grandparent &&
                  grandparent.previousElementSibling
                ) {
                  grandparent.previousElementSibling.classList.add("active")
                  grandparent.classList.add("show")
                }
              }
            }
          }
        }
      }, 0)
    },
  },
}
</script>

<template>
  <b-container fluid>
    <div id="two-column-menu"></div>

    <template v-if="layoutType === 'twocolumn'">
      <SimpleBar class="navbar-nav" id="navbar-nav">
        <li class="nav-item" v-if="isAdmin">
          <router-link class="nav-link menu-link" :to="{ name: 'operators' }">
            <i class="mdi mdi-account-supervisor-outline"></i>
            <span data-key="t-operator">{{ $t("t-operator") }}</span>
          </router-link>
        </li>
        <!-- end Operator -->

        <li class="nav-item">
          <b-link
            class="nav-link menu-link"
            href="#sidebarDashboards"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="sidebarDashboards"
          >
            <i class="mdi mdi-cube-outline"></i>
            <span data-key="t-products"> {{ $t("t-products") }}</span>
            <span
              v-if="
                isAdmin || isOperator ? faqCount > 0 || commentCount > 0 : false
              "
              class="badge rounded-circle bg-danger p-2 ms-2 d-block"
            ></span>
          </b-link>
          <div class="collapse menu-dropdown" id="sidebarDashboards">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  :to="{ name: 'product.categories' }"
                  class="nav-link"
                  data-key="t-product-categories"
                >
                  {{ $t("t-product-categories") }}
                </router-link>
              </li>

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  :to="{ name: 'product.attributes' }"
                  class="nav-link"
                  data-key="t-product-attributes"
                >
                  {{ $t("t-product-attributes") }}
                </router-link>
              </li>

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  :to="{ name: 'attribute.values' }"
                  class="nav-link"
                  data-key="t-attribute-values"
                >
                  {{ $t("t-attribute-values") }}
                </router-link>
              </li>

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  :to="{ name: 'tags' }"
                  class="nav-link"
                  data-key="t-tags"
                >
                  {{ $t("t-tags") }}
                </router-link>
              </li>

              <li class="nav-item">
                <router-link
                  v-if="isAdmin || isOperator"
                  :to="{ name: 'product.products' }"
                  class="nav-link"
                  data-key="t-products"
                >
                  {{ $t("t-products") }}
                </router-link>

                <router-link
                  v-else-if="isSeller"
                  :to="{ name: 'store.product.products' }"
                  class="nav-link"
                  data-key="t-products"
                >
                  {{ $t("t-products") }}
                </router-link>
              </li>

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  :to="{ name: 'faqs' }"
                  class="nav-link"
                  data-key="t-faqs"
                >
                  {{ $t("t-faqs") }}
                  <b-badge
                    v-if="isAdmin || isOperator ? faqCount > 0 : false"
                    variant="danger"
                    class="badge-pill"
                    data-key="t-new"
                    >{{ faqCount }}</b-badge
                  >
                </router-link>
              </li>

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  :to="{ name: 'comments' }"
                  class="nav-link"
                  data-key="t-comments"
                >
                  {{ $t("t-comments") }}
                  <b-badge
                    v-if="commentCount > 0"
                    variant="danger"
                    class="badge-pill"
                    data-key="t-new"
                    >{{ commentCount }}</b-badge
                  >
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <!-- end Product Menu -->

        <li class="nav-item" v-if="isAdmin || isOperator">
          <router-link class="nav-link menu-link" :to="{ name: 'users' }">
            <i class="mdi mdi-account-group-outline"></i>
            <span data-key="t-users">{{ $t("t-users") }}</span>
          </router-link>
        </li>
        <!-- end users -->

        <li class="nav-item" v-if="isAdmin || isOperator">
          <b-link
            class="nav-link menu-link"
            href="#sliderbanner"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="sliderbanner"
          >
            <i class="mdi mdi-image-multiple-outline"></i>
            <span data-key="t-sliderbanner"> {{ $t("t-sliderbanner") }}</span>
          </b-link>
          <div class="collapse menu-dropdown" id="sliderbanner">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item">
                <router-link
                  :to="{ name: 'sliders' }"
                  class="nav-link"
                  data-key="t-slider"
                >
                  {{ $t("t-slider") }}
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'ads' }"
                  class="nav-link"
                  data-key="t-ads-banners"
                >
                  {{ $t("t-ads-banners") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!-- end sliders and banners -->

        <li class="nav-item" v-if="isAdmin || isOperator">
          <router-link class="nav-link menu-link" :to="{ name: 'stores' }">
            <i class="mdi mdi-storefront-outline"></i>
            <span data-key="t-stores">{{ $t("t-stores") }}</span>
          </router-link>
        </li>
        <!-- end stores -->

        <li class="nav-item" v-if="isAdmin">
          <router-link class="nav-link menu-link" :to="{ name: 'settings' }">
            <i class="mdi mdi-cog-outline"></i>
            <span data-key="t-settings">{{ $t("t-settings") }}</span>
          </router-link>
        </li>
        <!-- end settings -->

        <li class="nav-item">
          <router-link v-if="isAdmin || isOperator"  class="nav-link menu-link" :to="{ name: 'orders' }">
            <i class="mdi mdi-shopping-outline"></i>
            <span data-key="t-orders">{{ $t("t-orders") }}</span>
            <b-badge
              v-if="orderCount > 0"
              variant="danger"
              class="badge-pill"
              data-key="t-new"
              >{{ orderCount }}</b-badge
            >
          </router-link>

          <router-link v-else-if="isSeller " class="nav-link menu-link" :to="{ name: 'store.orders' }">
            <i class="mdi mdi-shopping-outline"></i>
            <span data-key="t-orders">{{ $t("t-orders") }}</span>
            >
          </router-link>
        </li>
        <!-- end orders -->

        <li class="nav-item" v-if="isAdmin || isOperator">
          <router-link class="nav-link menu-link" :to="{ name: 'messages' }">
            <i class="mdi mdi-message-text-outline"></i>
            <span data-key="t-messages">
              {{ $t("t-messages") }}
            </span>
            <b-badge
              v-if="messageCount > 0"
              variant="danger"
              class="badge-pill"
              data-key="t-new"
              >{{ messageCount }}</b-badge
            >
          </router-link>
        </li>
        <!-- end messages -->

        <li class="nav-item" v-if="isAdmin || isOperator">
          <router-link
            class="nav-link menu-link"
            :to="{ name: 'cooperation.requests' }"
          >
            <i class="mdi mdi-handshake-outline"></i>
            <span data-key="t-cooperation-requests">
              {{ $t("t-cooperation-requests") }}
            </span>
            >
          </router-link>
        </li>
        <!-- end cooperation requests -->

        <li class="nav-item">
          <b-link
            class="nav-link menu-link"
            href="#financial"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="financial"
          >
            <i class="mdi mdi-cash-multiple"></i>
            <span data-key="t-financial"> {{ $t("t-financial") }}</span>
          </b-link>
          <div class="collapse menu-dropdown" id="financial">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item" v-if="isAdmin">
                <router-link
                  :to="{ name: 'financial.transactions' }"
                  class="nav-link"
                  data-key="t-transactions"
                >
                  {{ $t("t-transactions") }}
                </router-link>
              </li>

              <li class="nav-item" v-if="isSeller">
                <router-link
                  :to="{ name: 'store.products.unsettled' }"
                  class="nav-link"
                  data-key="t-unsettled-products"
                >
                  {{ $t("t-unsettled-products") }}
                </router-link>
              </li>

              <li class="nav-item" v-if="isSeller">
                <router-link
                  :to="{ name: 'store.settlement.payments' }"
                  class="nav-link"
                  data-key="t-settlement-payments"
                >
                  {{ $t("t-settlement-payments") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <!-- end Financial Menu -->

        <li class="nav-item" v-if="isAdmin || isOperator">
          <b-link
            class="nav-link menu-link"
            href="#reminders"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="reminders"
          >
            <i class="mdi mdi-bell-ring-outline"></i>
            <span data-key="t-reminders"> {{ $t("t-reminders") }}</span>
          </b-link>
          <div class="collapse menu-dropdown" id="reminders">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item">
                <router-link
                  :to="{ name: 'occasion.occasions' }"
                  class="nav-link"
                  data-key="t-occasions"
                >
                  {{ $t("t-occasions") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <!-- end reminders Menu -->
      </SimpleBar>
    </template>

    <template v-else>
      <ul class="navbar-nav h-100" id="navbar-nav">
        <li class="nav-item">
          <router-link
            class="nav-link menu-link"
            :to="
              isAdmin || isOperator
                ? { name: 'dashboard' }
                : { name: 'store.dashboard' }
            "
          >
            <i class="mdi mdi-speedometer"></i>
            <span data-key="t-dashboard">{{ $t("t-dashboard") }}</span>
          </router-link>
        </li>
        <!-- end Dashboard -->

        <li class="nav-item" v-if="isAdmin">
          <router-link class="nav-link menu-link" :to="{ name: 'operators' }">
            <i class="mdi mdi-account-supervisor-outline"></i>
            <span data-key="t-operator">{{ $t("t-operator") }}</span>
          </router-link>
        </li>
        <!-- end Operator -->

        <li class="nav-item">
          <b-link
            class="nav-link menu-link"
            href="#sidebarProducts"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="sidebarProducts"
          >
            <i class="mdi mdi-cube-outline"></i>
            <span data-key="t-products"> {{ $t("t-products") }}</span>
            <span
              v-if="
                isAdmin || isOperator ? faqCount > 0 || commentCount > 0 : false
              "
              class="badge rounded-circle bg-danger p-2 ms-2 d-block"
            ></span>
          </b-link>
          <div class="collapse menu-dropdown" id="sidebarProducts">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  :to="{ name: 'product.categories' }"
                  class="nav-link"
                  data-key="t-product-categories"
                >
                  {{ $t("t-product-categories") }}
                </router-link>
              </li>

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  :to="{ name: 'product.attributes' }"
                  class="nav-link"
                  data-key="t-product-attributes"
                >
                  {{ $t("t-product-attributes") }}
                </router-link>
              </li>

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  :to="{ name: 'attribute.values' }"
                  class="nav-link"
                  data-key="t-attribute-values"
                >
                  {{ $t("t-attribute-values") }}
                </router-link>
              </li>

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  :to="{ name: 'tags' }"
                  class="nav-link"
                  data-key="t-tags"
                >
                  {{ $t("t-tags") }}
                </router-link>
              </li>

              <li class="nav-item">
                <router-link
                  v-if="isAdmin || isOperator"
                  :to="{ name: 'product.products' }"
                  class="nav-link"
                  data-key="t-products"
                >
                  {{ $t("t-products") }}
                </router-link>

                <router-link
                  v-else-if="isSeller"
                  :to="{ name: 'store.product.products' }"
                  class="nav-link"
                  data-key="t-products"
                >
                  {{ $t("t-products") }}
                </router-link>
              </li>

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  :to="{ name: 'faqs' }"
                  class="nav-link"
                  data-key="t-faqs"
                >
                  {{ $t("t-faqs") }}
                  <b-badge
                    v-if="isAdmin || isOperator ? faqCount > 0 : false"
                    variant="danger"
                    class="badge-pill"
                    data-key="t-new"
                    >{{ faqCount }}</b-badge
                  >
                </router-link>
              </li>

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  :to="{ name: 'comments' }"
                  class="nav-link"
                  data-key="t-comments"
                >
                  {{ $t("t-comments") }}
                  <b-badge
                    v-if="commentCount > 0"
                    variant="danger"
                    class="badge-pill"
                    data-key="t-new"
                    >{{ commentCount }}</b-badge
                  >
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <!-- end Product Menu -->

        <li class="nav-item" v-if="isAdmin || isOperator">
          <router-link class="nav-link menu-link" :to="{ name: 'users' }">
            <i class="mdi mdi-account-group-outline"></i>
            <span data-key="t-users">{{ $t("t-users") }}</span>
          </router-link>
        </li>
        <!-- end users -->

        <li class="nav-item" v-if="isAdmin || isOperator">
          <b-link
            class="nav-link menu-link"
            href="#sliderbanner"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="sliderbanner"
          >
            <i class="mdi mdi-image-multiple-outline"></i>
            <span data-key="t-sliderbanner"> {{ $t("t-sliderbanner") }}</span>
          </b-link>
          <div class="collapse menu-dropdown" id="sliderbanner">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item">
                <router-link
                  :to="{ name: 'sliders' }"
                  class="nav-link"
                  data-key="t-slider"
                >
                  {{ $t("t-slider") }}
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'ads' }"
                  class="nav-link"
                  data-key="t-ads-banners"
                >
                  {{ $t("t-ads-banners") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!-- end sliders and banners -->

        <li class="nav-item" v-if="isAdmin || isOperator">
          <router-link class="nav-link menu-link" :to="{ name: 'stores' }">
            <i class="mdi mdi-storefront-outline"></i>
            <span data-key="t-stores">{{ $t("t-stores") }}</span>
          </router-link>
        </li>
        <!-- end stores -->

        <li class="nav-item" v-if="isAdmin">
          <router-link class="nav-link menu-link" :to="{ name: 'settings' }">
            <i class="mdi mdi-cog-outline"></i>
            <span data-key="t-settings">{{ $t("t-settings") }}</span>
          </router-link>
        </li>
        <!-- end settings -->

        <li class="nav-item">
          <router-link v-if="isAdmin || isOperator" class="nav-link menu-link" :to="{ name: 'orders' }">
            <i class="mdi mdi-shopping-outline"></i>
            <span data-key="t-orders">{{ $t("t-orders") }}</span>
            <b-badge
              v-if="orderCount > 0"
              variant="danger"
              class="badge-pill"
              data-key="t-new"
              >{{ orderCount }}</b-badge
            >
          </router-link>

          <router-link v-else-if="isSeller" class="nav-link menu-link" :to="{ name: 'store.orders' }">
            <i class="mdi mdi-shopping-outline"></i>
            <span data-key="t-orders">{{ $t("t-orders") }}</span>
          </router-link>
        </li>
        <!-- end orders -->

        <li class="nav-item" v-if="isAdmin || isOperator">
          <router-link class="nav-link menu-link" :to="{ name: 'messages' }">
            <i class="mdi mdi-message-text-outline"></i>
            <span data-key="t-messages">{{ $t("t-messages") }}</span>
            <b-badge
              v-if="messageCount > 0"
              variant="danger"
              class="badge-pill"
              data-key="t-new"
              >{{ messageCount }}</b-badge
            >
          </router-link>
        </li>
        <!-- end messages -->

        <li class="nav-item" v-if="isAdmin || isOperator">
          <router-link
            class="nav-link menu-link"
            :to="{ name: 'cooperation.requests' }"
          >
            <i class="mdi mdi-handshake-outline"></i>
            <span data-key="t-cooperation-requests">{{
              $t("t-cooperation-requests")
            }}</span>
          </router-link>
        </li>
        <!-- end cooperation requests -->

        <li class="nav-item">
          <b-link
            class="nav-link menu-link"
            href="#financial"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="financial"
          >
            <i class="mdi mdi-cash-multiple"></i>
            <span data-key="t-financial"> {{ $t("t-financial") }}</span>
          </b-link>
          <div class="collapse menu-dropdown" id="financial">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item" v-if="isAdmin">
                <router-link
                  :to="{ name: 'financial.transactions' }"
                  class="nav-link"
                  data-key="t-transactions"
                >
                  {{ $t("t-transactions") }}
                </router-link>
              </li>

              <li class="nav-item" v-if="isSeller">
                <router-link
                  :to="{ name: 'store.products.unsettled' }"
                  class="nav-link"
                  data-key="t-unsettled-products"
                >
                  {{ $t("t-unsettled-products") }}
                </router-link>
              </li>

              <li class="nav-item" v-if="isSeller">
                <router-link
                  :to="{ name: 'store.settlement.payments' }"
                  class="nav-link"
                  data-key="t-settlement-payments"
                >
                  {{ $t("t-settlement-payments") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <!-- end Financial Menu -->

        <li class="nav-item" v-if="isAdmin || isOperator">
          <b-link
            class="nav-link menu-link"
            href="#reminders"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="reminders"
          >
            <i class="mdi mdi-bell-ring-outline"></i>
            <span data-key="t-reminders"> {{ $t("t-reminders") }}</span>
          </b-link>
          <div class="collapse menu-dropdown" id="reminders">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item">
                <router-link
                  :to="{ name: 'occasion.occasions' }"
                  class="nav-link"
                  data-key="t-occasions"
                >
                  {{ $t("t-occasions") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <!-- end reminders Menu -->
      </ul>
    </template>
  </b-container>
</template>
